import script from "./DataReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DataReport.vue?vue&type=script&setup=true&lang=js"

import "./DataReport.vue?vue&type=style&index=0&id=aafc2302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aafc2302"]])

export default __exports__